import { render, staticRenderFns } from "./WeTransfer.vue?vue&type=template&id=a92645b8"
import script from "./WeTransfer.vue?vue&type=script&lang=js"
export * from "./WeTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports